import _Loading from "@kibt/meta-ui/es/loading";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { computed, defineComponent, onBeforeMount, watch } from '@vue/composition-api';
import { backOrClose, isInApp } from '@/utils/yoda';
import BlackMonth from './black-month.vue';
import { handleError } from '@/utils/handle-error';
import { logger } from '@/utils/logger';
import useStore from './store';
import MyTop from './components/top.vue';
import { lrpx2px, statusBarHeight } from '@/utils/device';
export default defineComponent({
  components: {
    MLoading: _Loading,
    MyTop: MyTop,
    BlackMonth: BlackMonth
  },
  setup: function setup() {
    var store = useStore();

    var initData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.fmp();
                _context.next = 3;
                return handleError({
                  result: -1,
                  error_msg: 'Acabou a atividade'
                }, 'Voltar');

              case 3:
                backOrClose(); // const ret = await store.initData();
                // if (ret.result !== 1) {
                //     await handleError(ret, true);
                //     await initData();
                // }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();

    watch(function () {
      return store.activeVenue;
    }, function () {
      if (store.activeVenue) {
        document.body.style.background = store.activeVenue.mainBackground;
      }
    }, {
      immediate: true
    });
    onBeforeMount(function () {
      logger.kwailog.sendPv({
        page: 'BLACK_MONTH'
      });
      initData();
    });
    var style = computed(function () {
      if (store.activeVenue && store.postVenue) {
        var _store$recentlyOpened;

        return {
          '--bar-height': "".concat(lrpx2px(40), "px"),
          '--main-background': store.activeVenue.mainBackground,
          '--button-background': store.activeVenue.buttonBackground,
          '--appointment-date-color': store.activeVenue.appointmentDateColor,
          '--post-color': store.postVenue.postColor,
          '--post-button-background': store.postVenue.buttonBackground,
          '--post-main-background': store.postVenue.mainBackground,
          '--rencently-button-background': (_store$recentlyOpened = store.recentlyOpenedVenue) === null || _store$recentlyOpened === void 0 ? void 0 : _store$recentlyOpened.buttonBackground
        };
      }

      return {};
    });
    return {
      isInApp: isInApp,
      store: store,
      statusBarHeight: statusBarHeight,
      style: style
    };
  }
});